<template>
<div>
    <b>Message Pattern(s)</b>
    <v-text-field
        v-for="(item, index) in patterns"
        :key="'pattern'+index"
        readonly
        disabled
        :value="item"
        autocomplete="off"
    />

    <b>Variables</b>
    <div
        v-for="(item, index) in variables"
        :key="'var'+index"
    >
        <v-text-field
            :label="prettyName(item.name)"
            v-model="params[item.name]"
            v-on:input="updateExampleMessage"
            autocomplete="off"
        />

        <p v-if="item.name == 'shipment-tracking-url'">
            <a v-on:click="onClickPopulateUsingTrackingNumber">Populate using tracking number</a>
        </p>
    </div>

    <b>Message</b>
    <v-textarea
        readonly
        disabled
        label="Message"
        :value="message"
        rows="1"
        auto-grow
    />

    {{example_sms_message}}
    
</div>
</template>

<script>
export default {
    props: {
        context: {
            type: String,
            default: function() { return 'manually-sent'; }
        },

        patterns: {
            type: Array,
            default: function() { return []; }
        }
    },   

    data() {
        return {
            variables: [],
            params: {},
            message: null,
            is_valid: false,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() 
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/message-patterns/variables',
            
                'params' : {
                        'context': this.context,
                        'patterns': this.patterns,
                    },
            
                'on_success': (data) => {
                        this.variables = data.results;
                        this.updateExampleMessage();
                    },
            
                'on_error': 'Unable to list variables',
            });
        },

        getParams()
        {
            return this.params;
        },

        isValid()
        {
            return this.is_valid;
        },

        updateExampleMessage()
        {
            let params = {
                'context' : this.context,
                'patterns' : this.patterns,
                'params' : this.params,
            };

            
            this.$rc.populateMessagePatterns(
                params,
            
                (data) => {
                    
                    if ( data.message == null )
                    {
                        this.message = 'Could not generate a message';
                        this.is_valid = false;
                        return;
                    }

                    this.message = data.message;
                    this.is_valid = true;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to populate message');
                },
            );
        },

        onClickPopulateUsingTrackingNumber()
        {
            this.$rc.prompt({
                'title' : 'Tracking number',
                'label' : 'Tracking number',
                'value' : this.params['shipment-tracking-number'],
                'after_prompt' : (value) => {
                    this.setTrackingNumber(value);
                }
            });
        },

        setTrackingNumber(tn)
        {
            this.$rc.showSpinner();
            
            this.$rc.parseShipmentTrackingNumber(
                tn,
            
                (data) => {
                    this.$rc.hideSpinner();

                    if ( data.tracking_url == null )
                    {
                        this.$rc.alert('Error','This is not a tracking number understood by RedChirp');
                        return;
                    }

                    this.params['shipment-tracking-url'] = data.tracking_url;
                    this.params['shipment-carrier-name'] = data.carrier;
                    this.params['shipment-tracking-number'] = data.tn;

                    this.updateExampleMessage();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        prettyName(name)
        {
            return '{'+name+'}';
        }
    },

    watch: {
        context(newValue, oldValue) {
            this.update();   
        },

        patterns(newValue, oldValue) {
            this.update();
        },
    },

    computed: {
        example_sms_message() {
            let ex = this.message;
            if ( ex == null || ex == 'Could not generate a message' ) return '';

            let send_type_msg = 'this message would send as an SMS.'
            if ( ex.length > 150 ) 
                send_type_msg = 'this message would send as an MMS.'

            return ex.length + ' / 150 -- '+send_type_msg;
        }
    },


}
</script>

<style lang="scss" scoped>

</style>